import { render, staticRenderFns } from "./OwnSuccessStories.vue?vue&type=template&id=0e636d04"
import script from "./OwnSuccessStories.vue?vue&type=script&lang=js"
export * from "./OwnSuccessStories.vue?vue&type=script&lang=js"
import style0 from "./OwnSuccessStories.vue?vue&type=style&index=0&id=0e636d04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports